// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"wk_a bhy_b bhy_we"};